// removed by extract-text-webpack-plugin
module.exports = {"hr":"app-pages-SuccessForgotPassword-__style___2WDWb","img":"app-pages-SuccessForgotPassword-__style___1hScH","text-email":"app-pages-SuccessForgotPassword-__style___3LvJe"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SuccessForgotPassword/style.css
// module id = 2241
// module chunks = 0